/* eslint-disable-next-line */
type FormTitleProps = {
  title: string;
};

export function FormTitle(props: FormTitleProps) {
  const { title } = props;

  return (
    <h3 className="text-header5 md:text-header3 font-MuseoSans100 text-center text-formGray mt-4">
      {title}
    </h3>
  );
}

export default FormTitle;
